import Slider from '../slider';

export default (element, data) => {
  const { rotationNumber } = data;
  const rotationNumberConverted = rotationNumber * 1000;
  let slider = null;
  let isPaused = false; 

  const initSlider = () => {
    if (element.querySelector('[data-promo-slider]')) {
      const prevEl = element.querySelector('[data-promo-slider-prev]');
      const nextEl = element.querySelector('[data-promo-slider-next]');
      const sliderToggle = element.querySelector('[data-promo-toggle]');

      slider = new Slider({
        el: element.querySelector('[data-promo-slider]'),
        options: {
          slidesPerView: 1,
          loop: true,
          mousewheel: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          autoplay: {
            delay: rotationNumberConverted,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          },
          navigation: {
            nextEl,
            prevEl,
          },
        },
      });

   
      const toggleAutoplay = async (e) => {
        e.preventDefault();
        prevEl.classList.add('hidden');
        nextEl.classList.add('hidden');
        if (!isPaused) {
          slider.swiper.autoplay.stop();
          isPaused = true; 
          sliderToggle.textContent = 'Play promotional slider'
        } else {
          await slider.swiper.autoplay.start();
          isPaused = false; 
           sliderToggle.textContent = 'Pause promotional slider'
        }
      };

      sliderToggle.addEventListener('click', toggleAutoplay);
    }

    return slider;
  };

  initSlider();
};
